const PHRASES = ["Roy A Smith", "Private Archive", "Photography", "Projects", "MMXXVI"];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {[...Array(3)].flatMap((_, r) =>
      PHRASES.map((p, i) => (
        <span key={`${r}-${i}`} className="flex items-center">
          <span className={`whitespace-nowrap px-8 ${i % 2 === 0 ? "font-display text-2xl font-light italic text-zinc-400 lg:text-3xl" : "font-mono text-[11px] uppercase tracking-[0.4em] text-zinc-400"}`}>
            {p}
          </span>
          <span className="h-1 w-1 rotate-45 bg-[#B08D2E]/50" />
        </span>
      )),
    )}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-ribbon" className="overflow-hidden border-y border-black/5 py-8">
    <div className="marquee-track flex w-max">
      <Strip />
      <Strip />
    </div>
  </div>
);
